import { Theme } from '@ui-system/theme';
import { F } from '@utils/ts';

import createFromProps from '../create-from-props';
import { Direction, FromProps } from '../types';

const applyDirection: F.Function<[Theme, Direction]> & FromProps = (
  theme,
  direction: Direction,
) => {
  if (!direction) return '';
  return `flex-direction: ${direction}`;
};
applyDirection.fromProps = createFromProps(applyDirection, 'direction');

export default applyDirection;
